import * as React from "react";
import { Link } from "react-router-dom";

import SummaryRow from "./SummaryRow";
import "./Summary.css";

export interface SummaryProps {
  cost: React.ReactChild;
  time: React.ReactChild;
  styles: React.ReactChild;
  layout: React.ReactChild;
  color: React.ReactChild;
  sampleNumber: string;
  productName: string;
  layoutImg?: string;
  submitError?: string;
  hasTOC: boolean;
  isTOCChecked: boolean;
  toggleTOCAgreement: () => void;
}

const Summary = (props: SummaryProps) => (
  <div className="summary">
    <div className="summary-pre">
      <div className="summary-pre__layout">
        {props.layoutImg && (
          <img className="img-responsive" src={props.layoutImg} />
        )}
      </div>
      <div className="summary-pre__estimate">
        <ul>
          <SummaryRow iconClass="cost" headerText="Giá">
            {props.cost}
          </SummaryRow>
          <SummaryRow iconClass="time" headerText="Thời gian">
            {props.time}
          </SummaryRow>
          <SummaryRow iconClass="deliverable" headerText="Số mẫu">
            {props.sampleNumber}
          </SummaryRow>
        </ul>
      </div>
    </div>
    <hr />
    <ul className="summary-after">
      <SummaryRow headerText="Sản phẩm">{props.productName}</SummaryRow>
      <SummaryRow headerText="Bố cục">{props.layout}</SummaryRow>
      <SummaryRow headerText="Phong cách">{props.styles}</SummaryRow>
      <SummaryRow headerText="Màu sắc">{props.color}</SummaryRow>
    </ul>
    {props.hasTOC && (
      <div className="summary__toc-block">
        <input
          id="toc"
          className="checkbox-inline"
          type="checkbox"
          checked={props.isTOCChecked}
          onChange={props.toggleTOCAgreement}
        />
        <label htmlFor="toc">
          <p>
            Tôi đồng ý với{" "}
            <Link to="/pages/terms" target="_blank">
              Điều khoản và Quy Định
            </Link>{" "}
            về thiết kế & thanh toán
          </p>
        </label>
      </div>
    )}
    {props.submitError && (
      <div className="summary__submit-error">{props.submitError}</div>
    )}
  </div>
);

export default Summary;



// WEBPACK FOOTER //
// ./src/routes/WizardSummary/components/Summary.tsx